import { InfoCircleOutlined } from '@ant-design/icons';
import { I18n } from '@aws-amplify/core';
import { Col, Row } from 'antd';
import React from 'react';

import { ApplyTool } from '../ApplyTool';
import { InfoTooltip } from './InfoTooltip';
import { Title } from './Title';
import { ITasksProps, ToolType } from './types';
import { Text } from '@/components/Typography';
import { useLocalStorage } from '@/hooks/useLocalStorage';

import * as S from './styles';

export function ToolCard({
	isActive = false,
	reportSelected = '',
	title = '',
	subTitle,
	fileId = '',
	type,
	toolTip,
	toolTipPosition = 'right',
	showTitle = true,
	fullWidth = false
}: Readonly<ITasksProps>): JSX.Element {
	const [, setName] = useLocalStorage(reportSelected, true);
	const description: string = isActive ? 'Tool already set' : 'Tool not set yet';

	const handleOperation = (toolName: ToolType): void => {
		const reportsInFullView: ToolType[] = [
			'niosh',
			'strain-index',
			'reba',
			'kim-mho',
			'kim-pp',
			'kim-lhc',
			'liberty-mutual',
			'back-compressive-force-estimation'
		];
		let url: string = `/reporting`;

		if (reportsInFullView.includes(toolName)) {
			url = `/reporting/${toolName}/${fileId}`;
		}

		window.open(url, '_blank');
	};

	const addSettings = (toolName: ToolType): void => {
		handleOperation(toolName);
		setName(true);
	};

	return (
		<Row>
			{showTitle && (
				<Col span={24} style={{ padding: 0 }}>
					<Title />
				</Col>
			)}
			{toolTip && toolTipPosition === 'top' && (
				<div>
					<InfoCircleOutlined style={{ fontSize: '0.7rem', marginRight: '0.3rem' }} />
					<Text>{toolTip}</Text>
				</div>
			)}
			<Col span={24} style={{ display: 'flex', alignItems: 'flex-start' }}>
				<ApplyTool
					type={type ?? 'toTop'}
					onClick={() => addSettings(reportSelected)}
					isActive={isActive}
					fullWidth={fullWidth}
				>
					<Text>{subTitle ? title : 'Load surveys'}</Text>
					<Text type="secondary">{subTitle ?? title}</Text>
				</ApplyTool>
				{toolTip && toolTipPosition === 'right' && (
					<div>
						<InfoTooltip text={toolTip} />
					</div>
				)}
			</Col>
			<Col span={24}>
				<S.Description isactive={isActive}>{I18n.get(description)}</S.Description>
			</Col>
		</Row>
	);
}

export { ToolCardGroup } from './ToolCardGroup';
